import { FederatedModule } from '@zenbusiness/application-commons-federation';
import Empty from '@zenbusiness/zui/Empty';

import { FEDERATED } from '#client/build-env';

function OrderSummary() {
  return (
    <FederatedModule
      exportName="OrderItemsDueWidget"
      silent
      {...FEDERATED.EcommerceUi}
      loadingElement={<Empty />}
    />
  );
}

export default OrderSummary;
